export default __webpack_public_path__ + "static/media/cctv2.5bc5d70b.PNG";